module.exports = __webpack_public_path__ + "img/master.0e0f16b8.png";